(function () {
  if (window.FVParallaxSlider) return;

  const instances = new Map();
  let listenersBound = false;
  let ticking = false;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function renderDots(instance) {
    const { dotsWrap, slides } = instance;
    if (!dotsWrap || slides.length <= 1) return;

    dotsWrap.innerHTML = '';
    slides.forEach(function (_, i) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'slider-dot' + (i === instance.current ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function () {
        go(instance, i);
        start(instance);
      });
      dotsWrap.appendChild(dot);
    });
  }

  function updateFvHotspotVisibility(instance) {
    if (!instance.root) return;
    instance.root.querySelectorAll('[data-fv-hotspot-overlay]').forEach(function (overlay) {
      overlay.querySelectorAll('[data-fv-slide-hotspot]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-fv-slide-hotspot'), 10);
        var show = idx === instance.current;
        el.style.visibility = show ? 'visible' : 'hidden';
        el.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    });
  }

  function go(instance, next) {
    instance.current = (next + instance.slides.length) % instance.slides.length;
    instance.slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === instance.current);
    });
    renderDots(instance);
    updateFvHotspotVisibility(instance);
    requestTick();
  }

  function start(instance) {
    if (instance.timer) clearInterval(instance.timer);
    if (instance.slides.length <= 1 || instance.autoplayMs <= 0) return;
    instance.timer = setInterval(function () {
      go(instance, instance.current + 1);
    }, instance.autoplayMs);
  }

  function bindArrowControls(instance) {
    var ac = new AbortController();
    instance.abortController = ac;
    var opts = { signal: ac.signal };
    const prevButton = instance.root.querySelector('[data-fv-prev]');
    const nextButton = instance.root.querySelector('[data-fv-next]');

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        function () {
          go(instance, instance.current - 1);
          start(instance);
        },
        opts
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        function () {
          go(instance, instance.current + 1);
          start(instance);
        },
        opts
      );
    }
  }

  /**
   * パララックス移動を fv-parallax-shift-layer に translateY で適用する。
   * 黒い背景が透けるのを防ぐため、同時に scale も適用して画像に余裕を持たせる。
   */
  function applyLayerParallaxShift(layer, shiftPx, isMobile, instance) {
    var shiftLayer = layer.querySelector('[data-fv-parallax-shift]');
    if (shiftLayer) {
      var h = Math.max(layer.getBoundingClientRect().height, 1);
      var base = instance && instance.parallaxMicroShift ? instance.parallaxMicroShift : 80;
      var maxShiftEver = base * 1.2;
      var s = 1 + (2 * maxShiftEver) / h;
      s = Math.min(Math.max(s, 1.28), 1.65);

      shiftLayer.style.transformOrigin = 'center center';
      shiftLayer.style.transform = 'translateY(' + shiftPx.toFixed(2) + 'px) scale(' + s.toFixed(4) + ')';
      shiftLayer.style.willChange = 'transform';

      // 画像の拡大率を打ち消すようにホットスポット（ツールチップ）に逆スケールを適用
      var hotspots = layer.querySelectorAll('.fv-hotspot');
      var invS = (1 / s).toFixed(4);
      hotspots.forEach(function (hp) {
        // 変数として設定することでCSS側の他のtransformと競合しないようにする
        hp.style.setProperty('--inv-scale', invS);
        hp.classList.add('is-ready');
      });
    }
  }

  function applyParallax(instance) {
    if (!instance.root && !instance.mainParallaxLayer) return;

    const isMobile = window.innerWidth <= 749;
    const easing = 0.15;
    const sectionRect = instance.section ? instance.section.getBoundingClientRect() : (instance.root ? instance.root.getBoundingClientRect() : null);
    if (!sectionRect) return;

    const parallaxActive = sectionRect.bottom > -300 && sectionRect.top < window.innerHeight + 300;
    
    let targetOverlapY = 0;
    let targetLiftY = 0;
    let targetMainShift = 0;
    let targetSliderShift = 0;

    if (parallaxActive) {
      // セクション自体の移動（Overlap/Lift）は無効化（ご要望により0に固定）
      targetOverlapY = 0;
      targetLiftY = 0;

      if (instance.mainParallaxLayer && instance.mainParallaxContainer) {
        const containerRect = instance.mainParallaxContainer.getBoundingClientRect();
        const progressMain = clamp((-containerRect.top) / Math.max(containerRect.height, 1), 0, 1);
        const easedMain = 1 - Math.pow(1 - progressMain, 2.0);
        targetMainShift = -easedMain * (instance.parallaxMicroShift || 80) * 1.15;
      }

      if (instance.root) {
        const denom = Math.max(window.innerHeight + sectionRect.height, 1);
        const progressSlider = clamp((window.innerHeight - sectionRect.top) / denom, 0, 1);
        const easedSlider = 1 - Math.pow(1 - progressSlider, 2.0);
        targetSliderShift = -easedSlider * (instance.parallaxMicroShift || 80) * 1.15;
      }
    }

    instance.curOverlapY = (instance.curOverlapY || 0) + (targetOverlapY - (instance.curOverlapY || 0)) * easing;
    instance.curLiftY = (instance.curLiftY || 0) + (targetLiftY - (instance.curLiftY || 0)) * easing;
    instance.curMainShift = (instance.curMainShift || 0) + (targetMainShift - (instance.curMainShift || 0)) * easing;
    instance.curSliderShift = (instance.curSliderShift || 0) + (targetSliderShift - (instance.curSliderShift || 0)) * easing;

    if (instance.root) {
      const totalY = instance.curOverlapY + instance.curLiftY;
      instance.root.style.transform = 'translateY(' + totalY.toFixed(2) + 'px)';
      
      var sliderLayers = Array.from(instance.root.querySelectorAll('.parallax.parallax-section'));
      sliderLayers.forEach(function (layer) {
        // 画像が絶対に見切れないよう、スケールを強化して再計算
        var h = Math.max(layer.getBoundingClientRect().height, 1);
        var base = instance.parallaxMicroShift || 80;
        var s = 1 + (base * 2.5) / h; // マージンを拡大
        s = Math.min(Math.max(s, 1.35), 1.8); // 最小拡大率を底上げ
        
        var maxSafeShift = (s - 1) * h / 2;
        var clampedShift = clamp(instance.curSliderShift, -maxSafeShift, maxSafeShift);
        applyLayerParallaxShift(layer, clampedShift, isMobile, instance);
      });
    }

    if (instance.mainParallaxLayer && instance.mainParallaxContainer) {
      var hMain = Math.max(instance.mainParallaxLayer.getBoundingClientRect().height, 1);
      var baseMain = instance.parallaxMicroShift || 80;
      var sMain = 1 + (baseMain * 2.5) / hMain;
      sMain = isMobile ? Math.min(Math.max(sMain, 1.5), 2.3) : Math.min(Math.max(sMain, 1.35), 1.8);
      
      instance.mainParallaxLayer.style.transform = 'translateY(' + instance.curMainShift.toFixed(2) + 'px) scale(' + sMain.toFixed(4) + ')';
      
      var mainHotspots = instance.mainParallaxLayer.querySelectorAll('.fv-hotspot');
      var invSMain = (1 / sMain).toFixed(4);
      mainHotspots.forEach(function (hp) {
        hp.style.setProperty('--inv-scale', invSMain);
        hp.classList.add('is-ready');
      });
    }

    // まだ動きに差があればフラグを立てて継続させる（requestTick側で判定）
    if (Math.abs(targetOverlapY - instance.curOverlapY) > 0.1 || 
        Math.abs(targetSliderShift - instance.curSliderShift) > 0.1) {
      return true;
    }
    return false;
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function animate() {
      let stillMoving = false;
      instances.forEach(function(instance) {
        if (applyParallax(instance)) stillMoving = true;
      });

      if (stillMoving) {
        requestAnimationFrame(animate);
      } else {
        ticking = false;
      }
    });
  }

  function bindGlobalListeners() {
    if (listenersBound) return;
    listenersBound = true;
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    document.addEventListener('shopify:section:load', requestTick);
    document.addEventListener('shopify:block:select', requestTick);
  }

  function initSection(sectionId) {
    var existing = instances.get(sectionId);
    if (existing) {
      if (existing.timer) clearInterval(existing.timer);
      if (existing.abortController) existing.abortController.abort();
      instances.delete(sectionId);
    }
    const root = document.querySelector('[data-fv-slider-root][data-section-id="' + sectionId + '"]');
    const bannerEl = document.getElementById('Banner-' + sectionId);
    const imageBannerBox = bannerEl ? bannerEl.querySelector('#image-banner-box') : null;
    const mainParallaxLayer = imageBannerBox
      ? imageBannerBox.querySelector('.fv-main-parallax-layer')
      : (bannerEl ? bannerEl.querySelector('.fv-main-parallax-layer') : null);
    const slider = root
      ? root.classList.contains('homepage_slider')
        ? root
        : root.querySelector('.homepage_slider')
      : null;
    const slides = root ? Array.from(root.querySelectorAll('[data-fv-slide]')) : [];
    const dotsWrap = root ? root.querySelector('[data-fv-dots]') : null;

    if (!root && !mainParallaxLayer) return;

    var maxShiftPx = 80;
    if (root && root.dataset.parallaxMaxShift) {
      var parsed = parseInt(root.dataset.parallaxMaxShift, 10);
      if (!isNaN(parsed) && parsed > 0) maxShiftPx = parsed;
    }
    const instance = {
      sectionId: sectionId,
      root: root,
      slider: slider,
      slides: slides,
      dotsWrap: dotsWrap,
      parallaxLayers: root ? Array.from(root.querySelectorAll('.parallax')) : [],
      mainParallaxContainer: imageBannerBox || bannerEl,
      mainParallaxLayer: mainParallaxLayer,
      autoplayMs: root ? parseInt(root.dataset.autoplayMs || '5000', 10) : 5000,
      overlapDesktop: root ? Math.max(parseInt(root.dataset.overlapDesktop || '160', 10), 0) : 160,
      overlapMobile: root ? Math.max(parseInt(root.dataset.overlapMobile || '100', 10), 0) : 100,
      overlapRange: root ? Math.max(parseInt(root.dataset.scrollLiftRange || '260', 10), 120) : 260,
      scrollLiftMax: root ? Math.max(parseInt(root.dataset.scrollLiftMax || '180', 10), 40) : 180,
      scrollLiftRange: root ? Math.max(parseInt(root.dataset.scrollLiftRange || '260', 10), 120) : 260,
      parallaxMicroShift: maxShiftPx,
      current: 0,
      timer: null
    };

    if (root) {
      root.querySelectorAll('.parallax[data-parallax-image]').forEach(function (el) {
        const src = el.getAttribute('data-parallax-image');
        /* 下部スライダーは img のみ表示（CSS で背景オフ）。インライン背景を付けない */
        if (src && !el.closest('.homepage_slider')) {
          el.style.backgroundImage = 'url("' + src + '")';
        }
      });
      if (slider && slides.length) {
        bindArrowControls(instance);
        go(instance, 0);
        start(instance);
      }
    }

    if (mainParallaxLayer) {
      const mainSrc = mainParallaxLayer.getAttribute('data-parallax-image');
      if (mainSrc) mainParallaxLayer.style.backgroundImage = 'url("' + mainSrc + '")';
    }

    instances.set(sectionId, instance);
    applyParallax(instance);
    bindGlobalListeners();
  }

  window.FVParallaxSlider = {
    initSection: initSection
  };
})();
